import styled from 'styled-components';

export const StyledFooter = styled.footer`
	background-color: ${({ theme }) => theme.colors.footer};
	color: ${({ theme }) => theme.colors.white};
	padding: 50px 0 60px;
	z-index: 999;
	opacity: 0.98;

	ul {
		list-style-type: none;
		position: relative;
		flex: 3;
	}
	ul li {
		margin-bottom: 5px;
	}

	p {
		position: absolute;
		bottom: 0.9;
		text-align: center;
		line-height: 25px;
		padding: 15px 0;
		background-color: ${({ theme }) => theme.colors.primary};
		color: ${({ theme }) => theme.colors.header};

		width: 100%;
		box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px,
			rgba(0, 0, 0, 0.22) 0px 15px 12px;
	}

	a {
		color: ${({ theme }) => theme.colors.white};
		display: inline-flex;
		text-decoration: none;
		align-items: center;
		justify-content: center;
	}
	i {
		color: #fff;
		display: inline-flex;
		margin-right: 10px;
		height: 40px;
		width: 40px;
	}

	h2 {
		color: #fff;
		position: relative;
		top: 0;
		margin-bottom: 10px;
	}

	img {
		background-color: #fff;
		border-radius: 50%;
		margin-bottom: 40px;
	}

	@media (max-width: ${({ theme }) => theme.mobile}) {
		text-align: center;
		padding: 5% 0;
		ul {
			padding: 0;
		}
		p {
			padding-top: 10px;
			line-height: 1;
		}
		img {
			display: none;
		}
	}
	@media (max-width: ${({ theme }) => theme.tab}) {
		justify-content: space-between;
		align-items: flex-start;
		text-align: center;
		padding: 5% 0;
		ul {
			padding: 0;
		}
		p {
			padding-top: 10px;
			line-height: 1.25;
		}
		img {
			display: none;
		}
	}
	#mc_embed_signup {
		clear: left;
		width: 100%;
	}
	#mc-embedded-subscribe {
		padding-top: 150px;
	}
	#mc_embed_signup form {
		text-align: center;
		padding: 10px 0 10px 0;
	}
	.mc-field-group {
		display: inline-flex;
	} /* positions input field horizontally */
	#mc_embed_signup input.email {
		font-size: 15px;
		border: 1px solid #abb0b2;
		-webkit-border-radius: 3px;
		-moz-border-radius: 3px;
		border-radius: 5px;
		color: #343434;
		background-color: #fff;
		box-sizing: border-box;
		height: 46px;
		padding: 0px 0.5em;
		display: inline-flex;
		margin: 10px 0;

		vertical-align: top;
	}
	#mc_embed_signup label {
		display: block;
		font-size: 27.6px;
		padding-bottom: 30px;
		font-weight: bold;
	}
	#mc_embed_signup .clear {
		display: inline-flex;
	} /* positions button horizontally in line with input */
	#mc_embed_signup .button {
		display: inline-flex;
		flex-basis: 1;
		align-items: flex-start;
		border-radius: 50px;
		border: none;
		cursor: pointer;
		font-size: 13px;
		font-weight: 700;
		padding: 15px 60px;
		background-color: ${({ theme }) => theme.colors.golden};
		color: ${({ theme }) => theme.colors.white};
		margin: 10px;
		box-shadow: rgba(0, 0, 0, 0.15) 0px 15px 25px,
			rgba(0, 0, 0, 0.05) 0px 5px 10px;
	}
	#mc_embed_signup .button:hover {
		opacity: 0.9;
		transform: scale(0.98);
		cursor: pointer;
	}
	#mc_embed_signup div#mce-responses {
		float: left;
		top: -1.4em;
		padding: 0em 0.5em 0em 0.5em;
		overflow: hidden;
		width: 90%;
		margin: 0 5%;
		clear: both;
	}
	#mc_embed_signup div.response {
		margin: 1em 0;
		padding: 1em 0.5em 0.5em 0;
		font-weight: bold;
		float: left;
		top: -1.5em;
		z-index: 1;
		width: 80%;
	}
	#mc_embed_signup #mce-error-response {
		display: none;
	}
	#mc_embed_signup #mce-success-response {
		color: #529214;
		display: none;
	}
	#mc_embed_signup label.error {
		display: block;
		float: none;
		width: auto;
		margin-left: 1.05em;
		text-align: left;
		padding: 0.5em 0;
	}
	@media (max-width: 768px) {
		#mc_embed_signup input.email {
			width: 100%;
			margin-bottom: 5px;
		}
		#mc_embed_signup .clear {
			display: block;
			width: 100%;
		}
		#mc_embed_signup .button {
			width: 100%;
			margin: 0;
		}
	}
`;
